import { notFalsy } from './assertions.js';
export const nullable = (exp) => (notFalsy(exp) ? exp : null);
export const conditional = (exp) => (notFalsy(exp) ? exp : undefined);
export const conditionalString = (exp) => (notFalsy(exp) ? String(exp) : '');
export const conditionalArray = (...exp) => exp.filter((value) => notFalsy(value)).flat();
